<div class="px-6">
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="top-right" key="toastSuccess"></p-toast>
  <p-card styleClass="my-3">
    <p-fieldset legend="Filtros" [toggleable]="true">
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [scrollHeight]="'30rem'"
              [style]="stylePattern"
              [options]="contract"
              inputId="filtroGrupos"
              optionLabel="description"
              optionValue="id"
              [(ngModel)]="motiveOccurrenceFilter.contractId"
              [filter]="true"
              [readonly]="true"
              dropdownIcon="null"
              [disabled]="true"
              placeholder="Selecionar"
            >
              <ng-template let-grupos pTemplate="item">
                <div class="font-semibold text-center">
                  {{ grupos.description }}
                </div>
              </ng-template>
            </p-dropdown>
            <label htmlFor="filtroGrupos">Grupos</label>
          </span>
        </div>
        <div class="col-6">
          <span class="p-float-label">
            <input
            class="min-w-full"
            [style]="stylePattern"
            type="text"
            pInputText
            pTooltip="Informe parte da descrição do motivo de ocorrência para realizar a busca."
            tooltipPosition="top"
            [(ngModel)]="motiveOccurrenceFilter.description"
          />
            <label htmlFor="filterTipo">Descrição</label>

          </span>
        </div>
      </div>
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [options]="motiveOccurrenceType"
              [(ngModel)]="motiveOccurrenceFilter.type"
              optionLabel="name"
              optionValue="value"
              [style]="stylePattern"
              [showClear]="true"
              inputId="filterAgrupador"
              placeholder="Selecionar"
            ></p-dropdown>
            <label htmlFor="filterAgrupador">Agrupador</label>
          </span>
        </div>
        <div class="col-4 flex text-align: right;">
          <p-button
            class="block relative mr-2 top-100 -translate-y-100"
            [style]="{ height: '40px' }"
            label="Filtrar"
            (onClick)="getMotiveOccurrence(false, motiveOccurrenceFilter)"
            size="small"
            icon="pi pi-search"
            ></p-button>
            <p-button label="Primary" [outlined]="true"
              [disabled]="!this.motiveOccurrenceFilter.description && !this.motiveOccurrenceFilter.contractId && !this.motiveOccurrenceFilter.type"
              class="block relative top-100 -translate-y-100"
              [style]="{ height: '40px' }"
              label="Limpar Filtro"
              size="small"
              icon="pi pi-times"
              (onClick)="clearFilter()"
            ></p-button>
        </div>
      </div>
    </p-fieldset>
  </p-card>
  <p-card [styleClass]="!notFound ? '' : 'mb-3'">
    <p-toolbar [styleClass]="!notFound ? 'mb-4 gap-2' : ''">
      <ng-template pTemplate="left">
          <button pButton pRipple label="Novo Motivo Ocorrência" icon="pi pi-plus" class="p-button-primary mr-2" (click)="showDialogCreate()"></button>
      </ng-template>
    </p-toolbar>
    <p-table
    *ngIf="!notFound"
    [(first)]="first"
    [value]="motiveOccurrenceData"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [lazy]="true"
    [tableStyle]="{ 'min-width': '100%' }"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[50, 100, 150, 200]"
    (onLazyLoad)="getMotiveOccurrence($event, currentFilter)"
    >
      <ng-template pTemplate="header">
        <tr [style]="{ cursor: 'default' }">
          <th class="sort-header"
              [style]="{ 'text-align': 'center' }"
              (click)="customSort('description')"
              [ngClass]="{
                'sort-asc': selectedSort === 'description' && sortDirection === 1,
                'sort-desc': selectedSort === 'description' && sortDirection === -1,
                'sort-neutral': selectedSort !== 'description' || sortDirection === 0
              }">
            <b>Descrição</b>
            <i class="pi"
               [ngClass]="{
                 'pi-sort-amount-up': selectedSort === 'description' && sortDirection === 1,
                 'pi-sort-amount-down': selectedSort === 'description' && sortDirection === -1,
                 'pi-sort-alt': selectedSort !== 'description' || sortDirection === 0
               }"></i>
          </th>
          <th class="sort-header"
              [style]="{ 'text-align': 'center' }"
              (click)="customSort('type')"
              [ngClass]="{
                'sort-asc': selectedSort === 'type' && sortDirection === 1,
                'sort-desc': selectedSort === 'type' && sortDirection === -1,
                'sort-neutral': selectedSort !== 'type' || sortDirection === 0
              }">
            <b>Agrupador</b>
            <i class="pi"
              [ngClass]="{
                'pi-sort-amount-up': selectedSort === 'type' && sortDirection === 1,
                'pi-sort-amount-down': selectedSort === 'type' && sortDirection === -1,
                'pi-sort-alt': selectedSort !== 'type' || sortDirection === 0
              }"></i>
          </th>
          <th class="sort-header"
              [style]="{ 'text-align': 'center' }"
              (click)="customSort('serviceTime')"
              [ngClass]="{
                'sort-asc': selectedSort === 'serviceTime' && sortDirection === 1,
                'sort-desc': selectedSort === 'serviceTime' && sortDirection === -1,
                'sort-neutral': selectedSort !== 'serviceTime' || sortDirection === 0
              }">
            <b>Tempo de atendimento</b>
            <i class="pi"
               [ngClass]="{
                 'pi-sort-amount-up': selectedSort === 'serviceTime' && sortDirection === 1,
                 'pi-sort-amount-down': selectedSort === 'serviceTime' && sortDirection === -1,
                 'pi-sort-alt': selectedSort !== 'serviceTime' || sortDirection === 0
               }"></i>
          </th>
          <th class="text-center">Ação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-mOccurrence>
  <tr [style]="{ cursor: 'default' }">
    <td [style]="{ 'vertical-align': 'middle', 'text-align': 'left' }">
      {{ mOccurrence.description }}
    </td>
    <td [style]="{ 'vertical-align': 'middle', 'text-align': 'left' }">
      {{ formatTechnical(mOccurrence.type) }}
    </td>
    <td [style]="{ 'vertical-align': 'middle', 'text-align': 'left' }">
      {{ mOccurrence.serviceTime }} {{ mOccurrence.serviceTime === 1 ? 'hora' : 'horas' }}
    </td>
    <td class="text-center">
        <button
          pButton
          pRipple
          pTooltip="Editar ocorrência"
          tooltipPosition="top"
          icon="pi pi-pencil"
          class="p-button-rounded p-button-secondary mr-2"
          (click)="showEditDialog(mOccurrence)">
        </button>
        <button
          pButton
          pRipple
          pTooltip="Excluir ocorrência"
          tooltipPosition="top"
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger mr-2"
          (click)="openDeleteConfirm(mOccurrence.id, mOccurrence.description)">
        </button>
    </td>
  </tr>
</ng-template>
    </p-table>
  </p-card>
  <app-not-found-component
  *ngIf="notFound"
  [titulo]="tituloNotFound"
  [descricao]="descricaoNotFound"
  ></app-not-found-component>


  <p-confirmDialog [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"></p-confirmDialog>



  <p-dialog
  [(visible)]="showCreateDialog"
  [modal]="true"
  [dismissableMask]="true"
  styleClass="w-9 h-60"
  >
    <p-fieldset legend="{{ editMode ? 'Editar Motivo Ocorrência' : 'Criar Motivo Ocorrência' }}">
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [scrollHeight]="'30rem'"
              [style]="stylePattern"
              [options]="contract"
              inputId="filtroGrupos"
              [class]="!newMotiveOccurrence.contractId ? 'ng-invalid ng-dirty' : ''"
              [required]="true"
              optionLabel="description"
              [(ngModel)]="newMotiveOccurrence.contractId"
              optionValue="id"
              [filter]="true"
              [readonly]="true"
              dropdownIcon="null"
              placeholder="Selecionar"
              [required]="true"
            >
              <ng-template let-grupos pTemplate="item">
                <div class="font-semibold text-center">
                  {{ grupos.description }}
                </div>
              </ng-template>
            </p-dropdown>
            <label htmlFor="filtroGrupos">Grupos</label>
          </span>
        </div>
        <div class="col-6">
          <span class="p-float-label">
            <input
            [class]="!newMotiveOccurrence.description ? 'min-w-full ng-invalid ng-dirty' : 'min-w-full'"
            [style]="stylePattern"
            type="text"
            pInputText
            [(ngModel)]="newMotiveOccurrence.description"
            [required]="true"
            pTooltip="Informe a descrição do motivo da ocorrência."
            tooltipPosition="top"
          />
            <label htmlFor="filterTipo">Descrição</label>
          </span>
        </div>
      </div>
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [options]="motiveOccurrenceType"
              [(ngModel)]="newMotiveOccurrence.type"
              [required]="true"
              optionLabel="name"
              optionValue="value"
              [style]="stylePattern"
              inputId="filterAgrupador"
              pTooltip="Definir se é Técnico ou Não Técnico."
              tooltipPosition="top"
            ></p-dropdown>
            <label htmlFor="filterAgrupador">Agrupador</label>
          </span>
        </div>
        <div class="col-6">
          <span class="p-float-label">
            <input
            [class]="!newMotiveOccurrence.serviceTime ? 'ng-invalid ng-dirty' : ''"
            placeholder="Digite o valor"
            [style]="stylePattern"
            type="text"
            min="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            pInputText
            [(ngModel)]="newMotiveOccurrence.serviceTime"
            (keypress)="onlyNumbers($event)"
            [required]="true"
            pTooltip="Informe o tempo em horas (somente valores numéricos)."
            tooltipPosition="top"

          />
            <label htmlFor="filterTipo">Tempo de Atendimento (horas)</label>
          </span>
        </div>

      <div class="grid mt-3">
        <div class="col-10"></div>

        <div class="col-2 flex gap-2 justify-content-end">

          <p-button
          label="Salvar"
          [loading]="buttonLoading"
          (click)="editMode ? updateMotiveOccurrence() : createMotiveOccurrence()"
          size="small"
          icon="pi pi-save"
          [disabled]="!newMotiveOccurrence.description || !newMotiveOccurrence.serviceTime || !newMotiveOccurrence.contractId || !newMotiveOccurrence.type || buttonLoading || newMotiveOccurrence.serviceTime < 1">
        </p-button>

        <p-button label="Primary" [outlined]="true"
          label="Limpar"
          icon="pi pi-times"
          severity="primary"
          size="small"
          (click)="clearCreateForm()">
        </p-button>
        </div>
      </div>

      </div>
    </p-fieldset>
  </p-dialog>
</div>
